// src/components/Navbar.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoHAL from './LogoHAL';

function Navbar() {
  const { currentUser, userRole, userData } = useAuth();

  const getUserInitials = () => {
    if (!currentUser || !userData) return '?';
    const first = userData.firstName || '';
    const last = userData.lastName || '';
    if (!first && !last) {
      const email = currentUser.email || '';
      return email.length > 0 ? email[0].toUpperCase() : '?';
    }
    return (first[0] + (last[0] || '')).toUpperCase();
  };
  const userInitials = getUserInitials();

  const avatarStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    color: '#fff',
    fontWeight: 'bold',
    textDecoration: 'none',
    background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)'
  };

  // Mobile nav toggle
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  return (
    <nav className="navbar">
      <div className="nav-logo">
        <LogoHAL width={120} style={{ marginRight: '1rem' }} />
      </div>

      {/* Hamburger icon */}
      <div className="nav-toggle" onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Nav links */}
      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" onClick={() => setMenuOpen(false)}>
            About
          </Link>
        </li>
        {currentUser && userRole === 'engineer' && (
          <li>
            <Link to="/form" onClick={() => setMenuOpen(false)}>
              Form
            </Link>
          </li>
        )}
        <li>
          <Link to="/coming-soon" onClick={() => setMenuOpen(false)}>
            Coming Soon
          </Link>
        </li>
        {currentUser ? (
          <>
            <li>
              <Link
                to="/account"
                style={avatarStyle}
                onClick={() => setMenuOpen(false)}
              >
                {userInitials}
              </Link>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link to="/login" onClick={() => setMenuOpen(false)}>
                Login
              </Link>
            </li>
            <li>
              <Link to="/signup" onClick={() => setMenuOpen(false)}>
                Sign Up
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
